import React from 'react'
import {
    Box,
    Button,
    FormControl,
    TextField,
    Typography,
    Grid,
    Checkbox, 
    FormControlLabel, 
} from "@mui/material";
import { useSubscribeClausesMutation, useGetAllClauses } from '../../services/clausesService'
import { useSearchParams } from 'react-router-dom';
import { useToasts } from '../../hooks/useToasts'
import toast from "react-hot-toast"
import { SnackbarSuccess } from "../../components/base/SnackbarAlert/SnackbarSuccess";
import { LoadingButton } from "@mui/lab";
import { useTranslation } from "react-i18next";
import { useState, useEffect } from 'react';
import { Controller, useFieldArray, useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";

const clausesSchema = z.object({
    clause_id: z.string(),
    clause_text: z.string().optional(),
    clause_decision: z.boolean(),
});

const clausesFormSchema = z.object({
    subscribedClauses: z.array(clausesSchema),
});

// const clauses = [
//     {
//         "clause_id": "ff298c45-4fb8-480a-ae37-1142ecf06e5d",
//         "clause_text": "Wyrażam zgodę na przetwarzanie moich danych osobowych przez Olivia Home Sp. z o.o. z siedzibą w Gdańsku przy ul. Stefana Batorego 16/1A (dalej „Olivia Home”) w celach marketingowych, w tym związanych z prowadzeniem marketingu produktów lub usług własnych oraz innych osób",
//         "clause_decision": true
//     },
//     {
//         "clause_id": "ce736625-f031-4e15-bbb7-cc651b6e0bbe",
//         "clause_text": "Wyrażam zgodę na przesyłanie przez Olivia Home, w imieniu własnym lub na zlecenie innych osób, informacji handlowych drogą elektroniczną.",
//         "clause_decision": true
//     },
//     {
//         "clause_id": "6193fc94-5880-4fac-b096-f8e3abf7f3d6",
//         "clause_text": "Wyrażam zgodę na dostarczanie przez Olivia Home, w imieniu własnym lub na zlecenie innych osób, informacji handlowych drogą telefoniczną.",
//         "clause_decision": true
//     }
// ]

const ClauseSubscribePage = () => {
    const { t } = useTranslation();
    const [searchParams, setSearchParams] = useSearchParams();
    const personLeadId = searchParams.get("lead");
    const [clauseIsSubscribed, setClauseIsSubscribed] = useState(false)
    const { onFormErrors, onServerError } = useToasts();
    const { data: clauses, isLoading: isLoadingClauses} = useGetAllClauses(new URLSearchParams({clause_is_temporary: false}))

    const { control, handleSubmit, reset, watch } = useForm({
        resolver: zodResolver(clausesFormSchema),
    });
    const { fields, replace } = useFieldArray({
        control,
        name: "subscribedClauses",
    });

    useEffect(() => {
        if (!clauses) {
            return;
        }
        const formattedClauses = clauses?.results.map((clause) => ({
            clause_id: clause.id,
            clause_text: clause.clause_text,
            clause_decision: false,
        }));
        if (formattedClauses) {
            replace(formattedClauses);
        }
    }, [replace, clauses, reset]);

    const { mutate: setsubsctibeClauses, isPending } = useSubscribeClausesMutation({
        onSuccess: (data, variables, context) => {
            toast.custom(
                () => <SnackbarSuccess message={t("successfullyEditedClause")} />,
                {
                    position: "bottom-right",
                },
            );
            setClauseIsSubscribed(true)
        },
        onError: (error) => {
            onServerError(error);
        },
    });

    const onSubmit = () => {
        setsubsctibeClauses({
            personLeadId,
            clauses: watch("subscribedClauses")
        })
    };

    const isFormValid = watch("subscribedClauses")?.filter(clause=>clause.clause_decision === true)?.length === clauses?.results?.length

  return <>
        {clauseIsSubscribed && 
                <Typography color="primary" variant="h6">
                    {"Dodano subscrybcje"}
                </Typography>
        }
        {!clauseIsSubscribed && <Grid container>
            <Grid item xs={12}>
                <Typography color="primary" variant="h6"
                
                >
                    {"Chcesz dostawać wiecej informacji?"}
                </Typography>
            </Grid>
            <Grid container item xs={12} sx={{width: "100%"}} >
                {fields.map((dynamicField, index) => (
                    <Grid item xs={12} justifySelf={"flex-start"} textAlign={"left"}>
                        <Controller
                            key={dynamicField.clause_id}
                            name={`subscribedClauses.${index}.clause_decision`}
                            control={control}
                            render={({ field }) => (
                                <FormControlLabel
                                    disabled={false}
                                    control={
                                        <Checkbox
                                            {...field}
                                            checked={field.value}
                                        />
                                    }
                                    label={
                                        <Grid
                                            item
                                            direction={"column"}
                                            sx={{
                                                display: "flex",
                                                alignItems: "start",
                                            }}
                                        >
                                            <Typography variant="body2">
                                                {dynamicField.clause_text}
                                            </Typography>
                                        </Grid>
                                    }
                                />
                            )}
                        />
                    </Grid>
                ))}
                </Grid>
            <Grid item xs={12}>
                <Typography 
                variant="h6"
                color="primary"
                >
                    {"*Zaznacz wszystkie zgody"}
                </Typography>
            </Grid>
            <Grid
                item 
                xs={12}
                container
                direction="row"
                justifyContent="center"
                alignItems="center"
                spacing={3}
            >
                <Grid item xs={12} textAlign={"center"}>
                    <LoadingButton
                        style={{ minWidth: "100px" }}
                        variant="contained"
                        size="small"
                        fullWidth
                        onClick={onSubmit}
                        color={"primary"}
                        loading={isPending}
                        disabled={isPending || !isFormValid}
                    >
                        {"Wyślij"}
                    </LoadingButton>
                </Grid>
                {/* <Grid item xs={6} textAlign={"left"}>
                    <Button
                        color={"error"}
                        style={{ minWidth: "100px" }}
                        variant="contained"
                        size="small"
                        onClick={()=>{}}
                        disabled={isPending}
                    >
                        {t("false")}
                    </Button>
                </Grid> */}
            </Grid>
        </Grid>}
        </>
}

export default ClauseSubscribePage